export default {
  courseTypes: {
    0: {
      code: 'micro',
      name: '微课'
    },
    1: {
      code: 'mooc',
      name: '公开课'
    },
    2: {
      code: 'spoc',
      name: '班级课'
    },
    3: {
      code: 'training',
      name: '培训课'
    },
    4: {
      code: 'map',
      name: '图谱课'
    }
  }
}